import { render } from "./SideMenu.vue?vue&type=template&id=3ea07ec8&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=3ea07ec8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea07ec8"]])

export default __exports__